import { listSubheaderClasses } from '@mui/material'

export const SEARCH_AFTER = 8
export const SEARCH_ROW_HEIGHT = 53
export const SEARCH_LIST_MAX_HEIGHT = 314

const foldText = (text) => text.normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/\s+/g, ' ').trim().toLowerCase()

const labelText = (label) => (typeof label === 'string' || typeof label === 'number' ? String(label) : '')

export const normalizeQuery = (query) => foldText(String(query ?? ''))

export const matchesQuery = (item, needle) => !needle || foldText(labelText(item?.label)).includes(needle)

export const isDisabledOption = (item) => item?.type === 'Credit Card'

export const isSameValue = (optionValue, value) => (
  optionValue !== null && typeof optionValue === 'object'
    ? optionValue === value
    : String(optionValue) === String(value ?? '')
)

export const optionKey = (group, index) => (group === null ? `o-${index}` : `g${group}-o-${index}`)

export const visibleOptions = ({ menuItems, myListSubheader, needle }) => {
  const entries = myListSubheader?.length > 0
    ? myListSubheader.flatMap((header, group) => ((header?.value && menuItems?.[header.value]) || [])
      .map((item, index) => ({ item, key: optionKey(group, index), pickable: true })))
    : myListSubheader === undefined
      ? (menuItems || []).map((item, index) => ({ item, key: optionKey(null, index), pickable: !isDisabledOption(item) }))
      : []
  return entries.filter(({ item }) => matchesQuery(item, needle))
}

export const stepActive = (keys, activeKey, delta) => {
  const at = keys.indexOf(activeKey)
  if (at === -1) return delta > 0 ? keys[0] ?? null : null
  return keys[Math.min(Math.max(at + delta, 0), keys.length - 1)]
}

const HIGHLIGHT_STEPS = new Map([['ArrowDown', 1], ['ArrowUp', -1], ['PageDown', 5], ['PageUp', -5]])

export const highlightTarget = (eventKey, keys, activeKey, queryEmpty) => {
  if (HIGHLIGHT_STEPS.has(eventKey)) return stepActive(keys, activeKey, HIGHLIGHT_STEPS.get(eventKey))
  if (queryEmpty && eventKey === 'Home') return keys[0] ?? null
  if (queryEmpty && eventKey === 'End') return keys[keys.length - 1] ?? null
  return undefined
}

export const keepInView = (list, option, inset = 0) => {
  const top = option.offsetTop - inset
  const bottom = option.offsetTop + option.offsetHeight
  if (top < list.scrollTop) list.scrollTop = top
  else if (bottom > list.scrollTop + list.clientHeight) list.scrollTop = bottom - list.clientHeight
}

export const stickyInset = (option) => {
  let node = option.previousElementSibling
  while (node && !node.classList.contains(listSubheaderClasses.root)) node = node.previousElementSibling
  return node ? node.offsetHeight : 0
}

export const keepOptionInView = (list, option) => keepInView(list, option, stickyInset(option))

let searchListCount = 0

export const nextSearchListId = () => {
  searchListCount += 1
  return `dropdown-search-${searchListCount}`
}

export const optionDomId = (listId, key) => (listId && key ? `${listId}-${key}` : undefined)

export const scrollToOption = (list, key) => {
  const id = optionDomId(list?.id, key)
  const option = id ? document.getElementById(id) : null
  if (option) keepOptionInView(list, option)
}

export const scrollToLastChosen = (list) => {
  const chosen = list.querySelectorAll('[aria-selected="true"]')
  if (chosen.length) keepOptionInView(list, chosen[chosen.length - 1])
}

export const lockMenuSize = (paper, field, { width }) => {
  if (width) paper.style.width = `${paper.offsetWidth}px`
  if (paper.offsetTop < Math.round(field.getBoundingClientRect().bottom)) paper.style.height = `${paper.offsetHeight}px`
}

export const unlockMenuSize = (paper) => {
  paper.style.width = ''
  paper.style.height = ''
}

export const createHighlight = () => {
  let key = null
  const listeners = new Set()
  return {
    get: () => key,
    set: (next) => {
      if (next === key) return
      key = next
      listeners.forEach((listener) => listener())
    },
    subscribe: (listener) => {
      listeners.add(listener)
      return () => listeners.delete(listener)
    },
  }
}
